module.exports = __webpack_public_path__ + "img/demo1.750966e4.png";